// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 388 ? "2fbf9dd2" : chunkId) + "." + {"188":"a86fc870dc4748de","388":"68b45ef103a3f878"}[chunkId] + ".js";
};